import {
  DEBUGINFO_REQUEST,
  DEBUGINFO_SUCCESS,
  DEBUGINFO_FAILURE,
} from "../types/debugInfo.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
};
export const DebugInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEBUGINFO_REQUEST:
      return {
        ...state,
        storeItemResponse: "",
        loading: true,
      };
    case DEBUGINFO_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case DEBUGINFO_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
